enum OrderSyncType {
    INCREMENT,

    ORIGINAL_IDS,
}

export default OrderSyncType;
